import * as angular from 'angular';
import {IController, IScope} from "angular";
import * as _ from "lodash";

export class DeliveriesTableSubsetRowCtrl implements IController {
  service: any;
  isMultiSelect: any;
  checked: any;
  isExpended: any;
  showProNumber: boolean = false;
  toggle: Function;
  onExpand: Function;

  private groupToBackground: any;

  /* @ngInject */
  constructor(private $delivery, private $scope: IScope) {
  }

  $onInit() {
    if (_.get(this.service, 'id')) {
      this.$delivery(this.service.id).$bindCtrl(this.$scope, this, 'service');
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  checkBoxClick() {
    this.toggle({serviceId: this.service.id});
  }

  onBeforeExpand() {
    const hasRelations = _.some(this.service.taskList, (t) => {
      return t.relations && t.relations.length;
    });
    if (hasRelations) {
      this.onExpand({serviceId: this.service.id});
    }
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesTableSubsetRow', {
    require: {
      deliveriesTableSubsetCtrl: '^deliveriesTableSubset'
    },
    bindings: {
      service: '<',
      isMultiSelect: '<',
      checked: '<',
      isExpended: '<',
      showProNumber: '<',
      toggle: '&',
      onExpand: '&'
    },
    template: require('./deliveries-table-subset-row.html').default,
    controller: DeliveriesTableSubsetRowCtrl
  });
